import RailsResource from './rails-resource';

class CalendarService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'calendar',
      ajaxLoader: false
    });
  }

  // The times tell a session moved from the schedule board apart from the regular one of the slot.
  batchScheduleCard(batchScheduleId, date, startTime, endTime) {
    const query = startTime && endTime ? `?start_time=${startTime}&end_time=${endTime}` : '';
    return this.get(`${this.route}/batch-card/${batchScheduleId}/${date}${query}`, false);
  }

  attendanceCard(serviceId, date, startTime, endTime, enrollmentContractId) {
    return this.get(`${this.route}/attendance-card/${serviceId}/${date}/${startTime}/${endTime}/${!!enrollmentContractId ? enrollmentContractId : '-'}`, false);
  }
}

export default new CalendarService();
